<template>
  <VModalWidget :dismiss="dismiss" :submit="doSubmit" :submitting="submitting" :submitTitle="this.$t('create')">
    <template slot="title">{{ $t('title') }}</template>

    <template slot="content">
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-form>
        <v-text-field
          v-model.trim="form.display"
          :label="$t('displayName')"
          :error-messages="nameErrors"
          required
          @input="$v.form.display.$touch()"
          @blur="$v.form.display.$touch()"
          v-on:keyup.enter="doSubmit"
        />
        <flow-field
          :type-filter="entityType"
          :flow-id="form.flow_id"
          :set-flow-id="setFlowId"
          :errors="flowIdErrors"
          :flow-link="flowLink"
          :return-link="selfLink"
        />
        <v-text-field v-model.trim="form.description" :label="$t('description')" v-on:keyup.enter="doSubmit" />
      </v-form>
    </template>
  </VModalWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { VModalWidget, BaseForm, FormErrors } from '@argon/app/components'
import { NAMESPACE } from '../store'
import { NAMESPACE as FLOWS_NAMESPACE } from '@argon/evo/flows/store'
import { FlowField } from '@argon/evo/flows/components'
export default {
  name: 'NewBoardWidget',
  extends: BaseForm,
  components: {
    VModalWidget,
    FormErrors,
    FlowField
  },
  props: {
    entityType: String,
    dismiss: { type: Function, required: true },
    selfLink: { type: String, default: 'newBoard' },
    flowLink: { type: String, default: 'nestedNewFlow' }
  },
  validations: {
    form: {
      display: { required },
      flow_id: { required },
      description: {}
    }
  },
  data: () => ({
    form: {
      display: '',
      flow_id: null,
      description: ''
    },
    submitting: false
  }),
  computed: {
    ...mapState(FLOWS_NAMESPACE, ['flows']),
    nameErrors() {
      const errors = []
      if (!this.$v.form.display.$dirty) return errors
      !this.$v.form.display.required && errors.push(this.$t('required'))
      this.getServerErrors('display', errors)
      return errors
    },
    flowIdErrors() {
      const errors = []
      if (!this.$v.form.flow_id.$dirty) return errors
      !this.$v.form.flow_id.required && errors.push(this.$t('required'))
      this.getServerErrors('flow_id', errors)
      return errors
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['createBoard']),
    setFlowId(flowId) {
      this.form.flow_id = flowId
    },
    doSubmit() {
      if (this.$v.form.$invalid) {
        return this.$v.form.$touch()
      }
      this.submitting = true
      this.createBoard(this.form)
        .then((resp) => {
          this.dismiss()
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>

<style scoped>
.v-progress-linear {
  margin: 0;
}
</style>

<i18n>
{
  "en": {
    "create": "@:labels.create",
    "description": "@:labels.description",
    "displayName": "@:labels.displayName",
    "flow": "@:labels.flow",
    "flowLink": "Add a New Flow",
    "noFlow": "Before you can add a board you have to add a flow.",
    "required": "@:labels.required",
    "title": "New Board"
  },
  "fr": {
    "create": "@:labels.create",
    "displayName": "@:labels.displayName",
    "flow": "@:labels.flow",
    "flowLink": "Ajouter un nouveau flux",
    "noFlow": "Pour créer un tableau vous devez ajouter un flux.",
    "required": "@:labels.required",
    "title": "Nouveau tableau"
  }
}
</i18n>
